import { call, put, takeEvery, all } from 'redux-saga/effects';
import { fetchApiAuth } from '../utils/api';
import { fetchGeofencesSuccess, fetchGeofencesFailure, constants } from './geofenceActions';
import { triggerErrorNotification } from '../utils/notificationUtils';
import type { SagaIterator } from 'redux-saga';
import { Geofence } from '../../types';

type ApiResponse<T> = T;
type SafeError = { 
    message: string; 
    response?: { 
        data?: { 
            message?: string; 
        } 
    } 
};

const { FETCH_GEOFENCES_REQUEST } = constants;

function* fetchGeofences(): SagaIterator {
    try {
        const response: ApiResponse<Geofence[]> = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/get-all-triggers',
        });
        yield put(fetchGeofencesSuccess(response));
    } catch (err) {
        const e = err as SafeError;
        triggerErrorNotification(e.response?.data?.message ?? e.message);
        yield put(fetchGeofencesFailure(e.message));
    }
}

export default function* geofenceSaga() {
    yield all([
        takeEvery(FETCH_GEOFENCES_REQUEST, fetchGeofences),
    ]);
}
